import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';
import React from 'react';
import { Button, ButtonSize } from './Button';
import styles from './Placeholder.module.scss';

interface IPlaceholderProps {
    iconPosition?: 'left' | 'top';
    infoText?: React.ReactNode;
    actionButton?: {
        icon?: React.ReactNode;
        text: React.ReactNode;
        onClick(event: React.MouseEvent): void;
    };
    actionText?: string;
    action?(): void;
    contentClassName?: string;
}

export const Placeholder = (props: IPlaceholderProps & { icon: JSX.Element }) => {
    const { infoText, actionText, action, icon } = props;
    const iconPosition = props.iconPosition || 'top';

    const placeholderStyles = classNames(styles.placeholder, {
        [styles.left]: iconPosition === 'left'
    });

    const contentStyles = classNames(styles.content, props.contentClassName || '', {
        [styles.left]: iconPosition === 'left'
    });

    const actionButton = props.actionButton;

    return (
        <div className={placeholderStyles}>
            {icon}
            <div className={contentStyles}>
                {infoText && <div className={styles.text}>{infoText}</div>}
                {actionButton && (
                    <Button
                        startIcon={actionButton.icon}
                        color='primary'
                        testId='action-button'
                        size={ButtonSize.small}
                        onClick={actionButton.onClick}
                    >
                        {actionButton.text}
                    </Button>
                )}
                {actionText && (
                    <a className={styles.action} onClick={action}>
                        {actionText}
                    </a>
                )}
            </div>
        </div>
    );
};

export const LoadingPlaceholder = (props: IPlaceholderProps & { size?: number; thickness?: number }) => {
    const size = props.size || 40;
    const thickness = props.thickness || 5;

    return <Placeholder icon={<CircularProgress size={size} thickness={thickness} />} {...props} />;
};
